import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
  external?: boolean;
}
export function CTAButton({
  text = 'QUIERO RECUPERAR LA CONEXIÓN CON MI HIJO AHORA',
  className = '',
  href = '#offer',
  onClick,
  external = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    }
  };
  return <motion.a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center w-full md:w-auto px-8 py-4 text-center text-maternal-brown font-bold text-sm md:text-base rounded-full bg-gradient-to-r from-maternal-amber to-maternal-gold shadow-lg hover:shadow-xl transition-all duration-300 ${className}`} data-id="element-212">
      <Heart className="w-5 h-5 mr-2 fill-maternal-brown" data-id="element-213" />
      {text}
    </motion.a>;
}